import { InputNumberElement } from '@app/common';
import TextWithReferences from '../../TextWithReferences/TextWithReferences';
import RequiredAsterisk from '../RequiredAsterisk';

type Properties = {
    data: InputNumberElement;
    value?: string;
    setValue: (value: string) => void;
};

const InputNumber = (props: Properties) => {
    let inputEl: JSX.Element;
    if (props.data.wholeNumberOnly === true) {
        inputEl = (
            <input
                type="number"
                onChange={ev => {
                    const val = ev.target.value;
                    if (val === '' || /^-?\d+$/.test(val)) {
                        props.setValue(val);
                    }
                }}
                value={props.value}
                min={props.data.min}
                max={props.data.max}
            />
        );
    } else {
        inputEl = (
            <input
                type="number"
                onChange={ev => props.setValue(ev.target.value)}
                value={props.value}
                min={props.data.min}
                max={props.data.max}
            />
        );
    }

    return (
        <p className="page-input page-input-text">
            <label><TextWithReferences text={props.data.label || ''} /><RequiredAsterisk required={props.data.required} /></label>
            {inputEl}
        </p>
    );
};
export default InputNumber;